import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import logger from '../../../services/logger';

import { UpdateEmploymentReadinessDTO } from './form-employment-readiness.types';

export type EmploymentReadinessState = Partial<UpdateEmploymentReadinessDTO>;

const initialState: EmploymentReadinessState = {};

const employmentReadinessSlice = createSlice({
  name: 'formEmploymentReadiness',
  initialState,
  reducers: {
    update: (state, action: PayloadAction<EmploymentReadinessState>) => {
      logger.debug('Updating employment readiness state.', { state, action });
      Object.assign(state, { ...action.payload });
    },
  },
});

export const { update: updateEmploymentReadinessAction } = employmentReadinessSlice.actions;
export default employmentReadinessSlice.reducer;
